import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { ShareButton } from '../../../../../../../../../../../ShareButton';
import { Space } from '../../../../../../../../../../../Space';
import { DisclaimerLink, ReleaseDateDisplay } from './components';

export const ArticleReleaseDateAndShareContent = () => (
  <>
    <ReleaseDateDisplay />
    <Space />
    <DisclaimerLink />
    <Space />
    <ShareButton
      size="1.5rem"
      color={ouiStyle.Constants.Colors.primary}
      paddingVertical="none"
      paddingHorizontal="simple"
      borderRadius="none"
      borderColor={ouiStyle.Constants.Colors.transparent}
      cursor="pointer"
    />
  </>
);
